<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousFFView"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="25"></md-layout>
          <md-layout md-flex="40">
            <h2>Documentation NOC & AUTH</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <div class id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showVisibility"
              class="md-button-color-toggle md-active"
              @click="showOverflow"
              style
            >
              <span>Documentation - Noc</span>

              <md-list-expand>
                <md-list>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="70"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Current Date & Time</label>
                        <b-form-input :formatter="capitalizeAll" disabled v-model="NocModel.currentDate"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="60">
                      <md-layout md-flex="100">
                        <label>Importer Name</label>
                        <b-form-input :formatter="capitalizeAll"
                          id="importerName"
                          name="importerName"
                          v-model="NocModel.importerName"
                        ></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="60">
                      <md-layout md-flex="100">
                        <label>HBL No</label>
                        <b-form-input :formatter="capitalizeAll" id="hblNo" name="hblNo" v-model="NocModel.hblNo"></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>MBL No</label>
                        <b-form-input :formatter="capitalizeAll" id="mblNo" name="mblNo" v-model="NocModel.mblNo"></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="90">
                      <md-layout md-flex="100">
                        <label>Preparation of NOC for Shipping Line</label>
                      </md-layout>
                      <md-layout md-flex="100">
                        <quill-editor
                          style="width:100% !important;height:530px !important"
                          v-model="NocModel.nocPreparation"
                        ></quill-editor>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <hr class="hr-border" />

                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>

                    <md-layout md-flex="20">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="addNocDocumentation"
                        id="addButtonLoaderNoc"
                      >Submit Noc</md-button>

                      <md-spinner md-indeterminate id="loaderNoc" style="display:none"></md-spinner>
                    </md-layout>

                    <md-layout md-flex="15"></md-layout>
                    <md-layout md-flex="20" v-if="NocModel.ffNocId!=''">
                      <md-button
                        class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                        @click="Print('ConNocDoc',NocModel.uploadNocDoc)"
                        id="addButtonLoaderAuth"
                      >Print</md-button>
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <hr class="hr-s" />
        <div class="phone-viewport" id="railOut">
          <div>
            <md-list>
              <md-list-item id="showvehicleBooking" class="md-button-color-toggle md-active">
                <span>Documentation ­ Authorization Letter</span>

                <md-list-expand>
                  <md-list>
                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>
                      <md-layout md-flex="50">
                        <md-layout md-flex="100">
                          <label>Importer Name</label>
                          <b-form-input :formatter="capitalizeAll"
                            id="importerName"
                            name="importerName"
                            v-model="AuthModel.importerName"
                          ></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="15">
                        <md-layout md-flex="100">
                          <label>MBL NO</label>
                          <b-form-input :formatter="capitalizeAll" id="mblNo1" name="mblNo1" v-model="AuthModel.mblNo"></b-form-input>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="15">
                        <md-layout md-flex="100">
                          <label>Current Date & Time</label>
                          <b-form-input :formatter="capitalizeAll" disabled v-model="AuthModel.currentDate"></b-form-input>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="30">
                        <label>Container No./ Seal No.</label>
                        <quill-editor ref="containerSealNo" v-model="AuthModel.containerSealNo"></quill-editor>
                      </md-layout>
                    </md-layout>

                    <md-layout md-gutter class="labelMargtop">
                      <md-layout md-flex="5"></md-layout>

                      <md-layout md-flex="90">
                        <md-layout md-flex="100">
                          <label>Authorization Letter</label>
                        </md-layout>
                        <md-layout md-flex="100">
                          <quill-editor
                            style="width:100% !important;height:450px !important"
                            v-model="AuthModel.authLetter"
                          ></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>

                    <hr class="hr-border" />

                    <md-layout md-gutter>
                      <md-layout md-flex="40"></md-layout>

                      <md-layout md-flex="20">
                        <md-button
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                          @click="addAuthDocumentation"
                          id="addButtonLoaderAuth"
                        >Submit Auth</md-button>

                        <md-spinner md-indeterminate id="loaderAuth" style="display:none"></md-spinner>
                      </md-layout>
                      <md-layout md-flex="15"></md-layout>

                      <md-layout md-flex="20" v-if="AuthModel.ffairAuthId!=''">
                        <md-button
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                          @click="Print('ConAuthDoc',AuthModel.uploadAuthDoc)"
                          id="addButtonLoaderAuth"
                        >Print</md-button>
                      </md-layout>
                    </md-layout>
                  </md-list>
                </md-list-expand>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopData"
      @close="ProceedSail"
    ></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editconSeaImportId") != "" &&
      this.$sessionsStorage.get("editconSeaImportId") != undefined
    ) {
      this.$store.dispatch("setCurrentRoute", "/SeaImport/ConNocdoc");

      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      NocModel: {
        ffNocId: "",
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId"),
        receivingDate: "",
        nocPreparation: "",
        currentDate: "",
        mblNo: "",
        hblNo: "",
        importerName: "",

        containerSealNo: "",

        uploadNocDoc: "",
        containerInfo: ""
      },
      AuthModel: {
        ffairAuthId: "",
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId"),
        importerName: "",
        mblNo: "",
        currentDate: "",
        containerSealNo: "",
        authLetter: "",
        uploadAuthDoc: "",
        containerInfo: ""
      },
      NormalseaImportDataModel: {},

      railOutTableArray: [],
      deleteId: "",
      showVisible: false,

      validate: true,
      validateRail: true,
      toMain: "",
      toMainAuth: ""
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
     CustomLoader,
    quillEditor
  },
  computed: {},
  methods: {
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    routePage() {
      this.$router.push({
        path: "/ffExportCon/consoFclSailFpod"
      });
    },

    Print(dir, value) {
      window.open(`${this.docURL}/SeaImport/` + dir + "/" + value);
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_railouttable",
          tableId: "railOutTableId",
          isActive: "isRailTableActive",
          tableVal: this.deleteId
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deletePermanent.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            this.getData();
            this.deleteId = "";
          })
          .catch(error => {});
      }
    },

    JqueryFun() {
      //   return $(function() {
      //     return $("#railOuttariff").DataTable();
      //   });
    },

    ProceedSail() {},

    validateFFExport() {
      let validate_new = true;

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    showOverflow() {},

    addNocDocumentation() {
      if (this.validate != false) {
        $("#addButtonLoaderNoc").css("display", "none");
        $("#loaderNoc").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/con_addNocDoc.php`,
          data: JSON.stringify(this.NocModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loaderNoc").css("display", "none");
              $("#addButtonLoaderNoc").css("display", "block");
              if (this.NocModel.ffNocId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.NocModel.ffNocId = data.ffNocId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    addAuthDocumentation() {
      //   this.validateFFExport();
      if (this.validate != false) {
        $("#addButtonLoaderAuth").css("display", "none");
        $("#loaderAuth").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaImport/con_addAuthDoc.php`,
          data: JSON.stringify(this.AuthModel),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              $("#loaderAuth").css("display", "none");
              $("#addButtonLoaderAuth").css("display", "block");

              if (this.AuthModel.ffairAuthId == "") {
                this.alert.content = "Data Added Succesfully";
              } else {
                this.alert.content = "Data Updated Succesfully";
              }
              this.AuthModel.ffairAuthId = data.ffairAuthId;
              this.$refs["addPop"].open();
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    onClose22() {},

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear(),
        minute = d.getMinutes(),
        Hour = d.getHours(),
        second = d.getSeconds();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      let dateNew = [year, month, day].join("-");

      let minuteNew = [Hour, minute].join(":");

      return dateNew + " " + minuteNew;
    },
    getData() {
      let vehicle_drive = {
        conSeaImportId: this.$sessionsStorage.get("editconSeaImportId")
      };
      this.doLoading();

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/con_fetchNocDocumentation.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            Object.keys(data.NormalseaImportData[0]).map(x => {
              this.NormalseaImportDataModel[x] =
                data.NormalseaImportData[0][x] || "";
            });

            if (data.NocDocumentArray.length > 0) {
              Object.keys(this.NocModel).map(x => {
                this.NocModel[x] = data.NocDocumentArray[0][x] || "";
              });
            } else {
              this.NocModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              this.NocModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
              this.NocModel.hblNo = data.NormalseaImportData[0].secondBLNumber;
              this.NocModel.importerName =
                data.NormalseaImportData[0].importerName;

              this.toMain = "<p>HAPAG Lloyd India Pvt. Ltd</p><p>Mumbai.</p>";
              this.NocModel.currentDate = this.formatDate(new Date());

              if (data.LastPreparationNoc.length > 0) {
                this.NocModel.nocPreparation =
                  data.LastPreparationNoc[0].nocPreparation;
              } else {
                this.NocModel.nocPreparation =
                  "<b><p>To,</p><p>The Manager,</p>" +
                  this.toMain +
                  "</b> <br/><p>Dear Sir,</p><p>Re: MBL NO. <b><<--From Input MBL->></b></p><p>Re: HBL NO. <b><<--From Input HBL->></b></p><br/><p>We request you to kindly arrange to issue the DELIVERY ORDER in favor of M/S <b><<--From Input Importer->></b>  , collection of the necessary charges from the receiver at your end. We as the consignee, named on the MBL, hereby undertake to clear the shipment and pay to you as carrier, all such costs that may become payable if the consignment remains un­cleared or abandoned.</p><p>We further indemnify you for all such costs that may arise out of damage to the container while in our / Receiver’s possession.We agree to pay to you the differential payments as may become due in case the Receiver returns the container in the nominated CFS/Depot after the expiry of the validity date as mentioned on your DELIVERY ORDER.</p><p>Notwithstanding the foregoing and in addition thereto our obligations under the above mentioned Hapag Lloyd MBL are not affected and its terms & conditions still apply.</p><br/><b><p>Thanking You,</p><p>For: PRIDEL Pvt. Ltd.</p><p>Authorized Signatory</p></b>";
              }
            }

            if (data.AuthDocumentArray.length > 0) {
              Object.keys(this.AuthModel).map(x => {
                this.AuthModel[x] = data.AuthDocumentArray[0][x] || "";
              });
            } else {
              this.AuthModel.containerInfo =
                data.NormalseaImportData[0].containerInfo;
              this.AuthModel.mblNo = data.NormalseaImportData[0].firstBLNumber;
              this.AuthModel.hblNo = data.NormalseaImportData[0].secondBLNumber;
              this.AuthModel.importerName =
                data.NormalseaImportData[0].importerName;

              this.AuthModel.containerSealNo =
                data.NormalseaImportData[0].secondBLNumber;
              this.toMainAuth = "<p><b>New Delhi.</b></p><br/>";
              this.AuthModel.currentDate = this.formatDate(new Date());

              if (data.LastAuthLetter.length > 0) {
                this.AuthModel.authLetter = data.LastAuthLetter[0].authLetter;
              } else {
                this.AuthModel.authLetter =
                  "<br/><br/>" +
                  this.toMainAuth +
                  "<p>Dear Sir/Madam,</p><br/><p>Sub: Delivery Order Against MBL NO.<b><<--From Input MBL->></b> </p><p>Container No.</p><p><<--From Input Container->></p><br/><p>Ref to above shipment we hereby authorize to Mr <b><<--From Input Importer->></b> the bearer of this letter specimen signature is attested below to collect the DO and all other relevant documents against above.<p><br/><p>Therefore, you are requested to please handover the Delivery Order and all other relevant documents to him and oblige.<p><p>Specimen Signature Attested.<p><br/><b><p>Thanking You,<p><br/><p>Yours Faithfully,<p><p>For PRIDEL Pvt. Ltd.</p></b>";
              }
            }

            // this.JqueryFun();
            this.doLoadingClose();
            // window.scroll(0, 0);
          }
        })
        .catch(error => {});
    },

    deleteData(item) {
      this.deleteId = item.railOutTableId;

      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPop6"].open();
    },

    previousFFView() {
      this.$router.push({
        path: "/conSeaImport/ffConSeaImportExec"
      });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// seaConNocImportDocumentation.vue?791bc283